import './RouteTransitionOverlay.css';
import { useRouteTransitionContext } from '../../hooks/context/useRouteTransitionContext';
import PageContentTransition from '../PageContentTransition/PageContentTransition';

const RouteTransitionOverlay = () => {
  const { isTransitioning, isOverlayRequested } = useRouteTransitionContext();

  return (
    <div className="route-transition-overlay">
      <PageContentTransition
        isVisible={isTransitioning || isOverlayRequested}
      />
    </div>
  );
};

export default RouteTransitionOverlay;
